import { connect } from 'react-redux'

import {
  getUnit,
  getUnitWopi360Targets,
  removeWopi360TargetFromUnit,
  updateUnitWopi360TargetRelations
} from '../../ducks/unit'

import UnitDetails from '../UnitDetails'

export default connect(
  state => ({
    unit: state.unit.get('currentUnit'),
    isLoading: state.unit.get('isLoading'),
    wopi360Targets: state.unit.get('wopi360Targets'),
    wopi360TargetsPagination: state.unit.get('wopi360TargetsPagination'),
    currentLanguage: state.account.get('currentLanguage')
  }),
  {
    getUnit,
    getUnitWopi360Targets,
    removeWopi360TargetFromUnit,
    updateUnitWopi360TargetRelations
  }
)(UnitDetails)



// WEBPACK FOOTER //
// ./src/components/smart/UnitDetailsContainer.js